<script lang="ts" setup>

//vue
import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/planosService";
import * as contratosService from "@/services/clientesContratosService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import Editor from '@tinymce/tinymce-vue'
import PlanosItens from "./PlanosItens.vue";
import { fdata } from "@/utils/funcoes";

  const route = useRoute();

  var controle = reactive({

    model: {
      nome: "",
      ativo: true,
      tipo: "Familiar",
      texto: "", // Garantir que texto está inicializado
      permiteSeguro: false,

    } as service.Plano,
    tipos: ['Familiar', 'Empresarial'] ,
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],

      erro: "",
      status: "",

      janSincronizar: false,
      contratosPlano: [] as contratosService.Contrato[],
      selecionados: {} as Record<number, boolean>,
      statusSincronizar: "",
      erroSincronizar: "",
      resultadoSincronizar: [] as contratosService.ContratoSincronizarResultadoDTO[],
  })

  onMounted(() => {
    
    console.log("buscar")
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then(usuario => {
          controle.model = usuario;
          // Garantir que texto não seja null/undefined
          if (!controle.model.texto) {
            controle.model.texto = "";
          }
        })
        .catch(error => {
          controle.erro = `Erro ao carregar: ${error}`;
        });
    }

    setTimeout(() => {
      var el = document.getElementById("inputFocus");
      if (el) {
        el.focus();
      }
    }, 500);

  });

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)
       controle.status = "Salvo com sucesso!";
       setTimeout(() => {
         controle.status = "";
       }, 3000);
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
    }

  function abrirSincronizar() {
    if (!controle.model.planoId) return;

    controle.janSincronizar = true;
    controle.resultadoSincronizar = [];
    buscarContratosPlano();
  }

  function buscarContratosPlano() {
    controle.statusSincronizar = "Buscando contratos...";
    controle.erroSincronizar = "";

    contratosService.obter({ planoId: controle.model.planoId, tamanhoPagina: 1000 })
      .then((r) => {
        controle.contratosPlano = r;
        controle.selecionados = {};
        controle.statusSincronizar = "";
      })
      .catch((error) => {
        controle.erroSincronizar = `Erro ao buscar contratos: ${error.message || error}`;
        controle.statusSincronizar = "";
      });
  }

  function marcarTodos(valor: boolean) {
    controle.contratosPlano.forEach((item) => {
      controle.selecionados[item.contratoId] = valor;
    });
  }

  function aplicarSincronizacao() {
    const ids = Object.keys(controle.selecionados)
      .filter((id) => controle.selecionados[Number(id)])
      .map((id) => Number(id));

    if (ids.length === 0) {
      controle.erroSincronizar = "Selecione ao menos um contrato!";
      return;
    }

    controle.statusSincronizar = `Aplicando em ${ids.length} contrato(s)...`;
    controle.erroSincronizar = "";
    controle.resultadoSincronizar = [];

    contratosService.sincronizarTexto(ids)
      .then((r) => {
        controle.resultadoSincronizar = r;
        controle.statusSincronizar = "";
        buscarContratosPlano();
      })
      .catch((error) => {
        controle.erroSincronizar = `Erro ao sincronizar: ${error.message || error}`;
        controle.statusSincronizar = "";
      });
  }
</script>

<template>
  <BreadCrumb PageTitle="Cadastro de Planos" 
    :items="[ 
      { label: 'Planos', to: '/planos' }, 
      { label: 'Cadastro', to: '/planos/cadastro' } ]" />

    <Notificacao :erro="controle.erro" 
          @limparErro="controle.erro=''" 
          :progresso="controle.status" 
          @limparProgresso="controle.status = ''" />

    <TrataTecla>
      <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button class="nav-link active" id="nav-cadastro-tab" data-bs-toggle="tab" data-bs-target="#nav-cadastro" type="button" role="tab" aria-controls="nav-cadastro" aria-selected="true">Cadastro</button>
              <button class="nav-link" id="nav-adicionais-tab" data-bs-toggle="tab" data-bs-target="#nav-adicionais" type="button" role="tab" aria-controls="nav-adicionais" aria-selected="false">Adicionais</button>
              <button class="nav-link" id="nav-contrato-tab" data-bs-toggle="tab" data-bs-target="#nav-contrato" type="button" role="tab" aria-controls="nav-contrato" aria-selected="false">Contrato</button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane p-3 fade show active" id="nav-cadastro" role="tabpanel" aria-labelledby="nav-cadastro-tab" tabindex="0">
          <div class="row">

            <!-- coluna 1-->
            <div class="col-md-6">
              <div class="mb-2" style="max-width: 160px;">
                <label for="planoId" class="form-label">ID</label>
                <TextBox v-model="controle.model.planoId" id="planoId" :formato="'Numero'" readonly disabled />
              </div>

              <div class="mb-2">
                <label for="nome" class="form-label obrigatorio">Nome</label>
                <TextBox v-model="controle.model.nome" id="inputFocus"/>
              </div>

              <div class="mb-2">
                <label for="tipoId" class="form-label obrigatorio">Tipo</label>
                <select v-model="controle.model.tipo" id="tipoId" class="form-select form-select-sm" >
                  <option :value="null">- Selecione -</option>
                  <option v-for="(item,idx) in controle.tipos" :key="idx" :value="item">{{ item }}</option>
                </select>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="idadeMinima" class="form-label">Idade Mínima</label>
                <TextBox v-model="controle.model.idadeMinima" id="idadeMinima" :formato="'Numero'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="idadeMaxima" class="form-label">Idade Máxima</label>
                <TextBox v-model="controle.model.idadeMaxima" id="idadeMaxima" :formato="'Numero'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="maximoPessoas" class="form-label">Máximo de Pessoas</label>
                <TextBox v-model="controle.model.maximoPessoas" id="maximoPessoas" :formato="'Numero'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="valor" class="form-label">Valor R$</label>
                <TextBox v-model="controle.model.valor" id="valor"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 200px;">
                <label for="permiteSeguro" class="form-label">Permite Seguro?</label>
                <select v-model="controle.model.permiteSeguro" id="permiteSeguro" class="form-select form-select-sm" >
                  <option v-for="tipo in controle.simNao" :key="String(tipo.valor)" :value="tipo.valor">{{ tipo.texto }}</option>
                </select>
              </div>

              <div class="mb-2" style="max-width: 160px;" v-if="controle.model.permiteSeguro">
                <label for="valorComSeguro" class="form-label">Valor com Seguro R$</label>
                <TextBox v-model="controle.model.valorComSeguro" id="valorComSeguro"  :formato="'DoisDecimais'" class="text-end"/>
              </div>
            </div>

            <!-- coluna 2-->
            <div class="col-md-6">

              <div class="mb-2" style="max-width: 160px;">
                <label for="percInvestidor" class="form-label">Investidor %</label>
                <TextBox v-model="controle.model.percInvestidor" id="percInvestidor"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="percVendedor" class="form-label">Vendedor %</label>
                <TextBox v-model="controle.model.percVendedor" id="percVendedor"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="percSupervisor" class="form-label">Supervisor %</label>
                <TextBox v-model="controle.model.percSupervisor" id="percSupervisor"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="percIndicador" class="form-label">Indicador %</label>
                <TextBox v-model="controle.model.percIndicador" id="percIndicador"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="percMidia" class="form-label">Mídia %</label>
                <TextBox v-model="controle.model.percMidia" id="percMidia"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 160px;">
                <label for="percTi" class="form-label">TI %</label>
                <TextBox v-model="controle.model.percTi" id="percTi"  :formato="'DoisDecimais'" class="text-end"/>
              </div>

              <div class="mb-2" style="max-width: 200px;">
                <label for="ativo" class="form-label">Ativo</label>
                <select v-model="controle.model.ativo" id="ativo" class="form-select form-select-sm" >
                  <option :value="null">- Selecione -</option>
                  <option v-for="tipo in controle.simNao" :key="String(tipo.valor)" :value="tipo.valor">{{ tipo.texto }}</option>
                </select>
              </div>

            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-12">
              <label for="observacoes" class="form-label obrigatorio">Observações</label>
              <textarea v-model="controle.model.observacoes" id="observacoes"  class="form-control" rows="3"></textarea>
            </div>
          </div>

          </div>

          <div class="tab-pane p-3 fade" id="nav-adicionais" role="tabpanel" aria-labelledby="nav-adicionais-tab" tabindex="0">
            <PlanosItens :PlanoId="controle.model.planoId" />
          </div>

          <div class="tab-pane p-3 fade" id="nav-contrato" role="tabpanel" aria-labelledby="nav-contrato-tab" tabindex="0">
            <div class="row mb-2">
              <div class="col-md-12">
                <label class="mb-2">Variáveis disponíveis: [ASSINATURACONTRATADA] [CLIENTENOME] [CLIENTENASCIMENTO] [CLIENTECPF] [CONJUGENOME] [CONJUGECPF] [ASSINATURA] [DIA] [MES] [ANO]</label>
                <div class="mb-2" v-if="controle.model.planoId">
                  <a class="btn btn-sm btn-outline-primary" href="#" @click.prevent="abrirSincronizar()">
                    <i class="fa fa-sync me-1"></i> Aplicar texto atual aos contratos deste Plano
                  </a>
                </div>
                <label for="texto" class="form-label">Texto do Contrato</label>
                <editor
                  api-key="lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7"
                  :init="{
                    height: 700,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | removeformat | help'
                  }"
                  v-model="controle.model.texto"
                  @update:modelValue="(value: string | null) => controle.model.texto = value"
                />
              </div>
            </div>
          </div>

          </div>
        </div>
        <div class='card-footer'>
          <div class="row">
            <div class="col-md-2">
               <a class="btn btn-sm btn-primary " @click="salvar()">Gravar</a>
            </div>
            <div class="col-md-8">
              <div v-if="controle.erro == null && controle.status != null" class="fw-bold">{{ controle.status }}</div>
              <div v-if="controle.erro != null " class="fw-bold text-danger">{{ controle.erro }}</div>
            </div>
            <div class="col-md-2">
              <RouterLink class="btn btn-sm btn-secondary float-end" :to="'/planos'">Fechar</RouterLink>
            </div>
          </div>
        </div>
      </div>
    </TrataTecla>

  <MsgBox :id="'janSincronizar'" tamanho="modal-lg" data-bs-backdrop="static" :exibir="controle.janSincronizar"
    :titulo="'Aplicar texto do Plano aos Contratos'" @on-fechou="controle.janSincronizar = false"
    :botao-fechar="true">

    <p class="text-muted">
      Selecione os contratos que devem passar a usar o texto atual do Plano. Contratos já assinados também podem
      ser selecionados — a assinatura do cliente e da contratada são preservadas e reaplicadas ao novo texto.
    </p>

    <div class="mb-2">
      <a class="btn btn-sm btn-outline-secondary me-1" href="#" @click.prevent="marcarTodos(true)">Marcar todos</a>
      <a class="btn btn-sm btn-outline-secondary" href="#" @click.prevent="marcarTodos(false)">Desmarcar todos</a>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th class="text-center">Aplicar?</th>
            <th>Contrato</th>
            <th>Cliente</th>
            <th>Assinado em</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="controle.contratosPlano.length == 0">
            <td colspan="4" class="text-center">Nenhum contrato encontrado para este Plano</td>
          </tr>
          <tr v-for="item in controle.contratosPlano" :key="item.contratoId">
            <td class="text-center">
              <input type="checkbox" v-model="controle.selecionados[item.contratoId]" />
            </td>
            <td>{{ item.contratoId }}</td>
            <td>{{ item.cliente?.nome ?? item.empresa?.nome ?? '-' }}</td>
            <td>{{ item.dataAssinatura ? fdata(item.dataAssinatura) : 'Pendente' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-2">
      <a class="btn btn-sm btn-success" href="#" @click.prevent="aplicarSincronizacao()">
        <i class="fa fa-check me-1"></i> Aplicar Selecionados
      </a>
    </div>

    <div class="text-center mb-2">
      <span class="">{{ controle.statusSincronizar }}</span>
      <span class="text-danger fw-bold">{{ controle.erroSincronizar }}</span>
    </div>

    <div v-if="controle.resultadoSincronizar.length" class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>Contrato</th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in controle.resultadoSincronizar" :key="item.contratoId">
            <td>{{ item.contratoId }}</td>
            <td :class="item.sucesso ? 'text-success' : 'text-danger'">{{ item.mensagem }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </MsgBox>

</template>